import { Component, OnInit, Input, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import { FilterMatchMode, PrimeNGConfig } from 'primeng/api';
import { Calendar } from 'primeng/calendar';
import { PrivilegeService } from '../shared/privilege.service';
import { thousands_separators } from '../utils/utilities.function';
import { Table } from 'primeng/table';


@Component({
	selector: 'app-dynamic-table',
	templateUrl: './dynamic-table.component.html',
	styleUrls: ['./dynamic-table.component.scss']
})
export class DynamicTableComponent implements OnInit {
	date: any;
	tableType: any;

	@Input() tableSchema: any;
	@Input() selectedRows: any;
	@Input() actionClick:any

	@Input() emptyMessage: any;
	@Input() cols: any;
	@Input() value: any;
	@Input() dmpdata: any[] = [];
	@Input() scroll: any;
	@Input() resizableColumns: any;
	@Input() filterDropdown: any;
	@Input() filterDateRanges: any;
	@Input() appliedFilters: any;
	@Input() filteredDataList: any;
	@Input() inlineEdit: any;
	@Input() themes: any;
	@Input() disableDelete: any;
	@Input() headerSelectOptions: any;
	@Input() isLoading: boolean = false;
	@Input() disableDlt: any;
	@Input() hideScrollBar: any;
	@Input() badgeOptions: any;
	@Input() editEmailConfig = new EventEmitter();

	@Input() fundList: any;
	@Output() getMeTheFundName = new EventEmitter();
	@Output() messageData = new EventEmitter()
	@Output() showDialog = new EventEmitter();
	@Output() summary = new EventEmitter();
	@Output() getDataBasedOnRange = new EventEmitter();
	@Output() getDataBasedOnDate = new EventEmitter();
	@Output() getDataBasedOnHeader = new EventEmitter();
	@Output() geteventData = new EventEmitter()
	@Output() closeCalender = new EventEmitter();
	@Output() editInParent = new EventEmitter();
	@Output() stopInParent = new EventEmitter();
	@Output() viewInParent = new EventEmitter()
	@Output() viewMore = new EventEmitter()
	@Output() viewParams = new EventEmitter()
	@Output() viewLogo = new EventEmitter();
	@Output() updateInParent = new EventEmitter();
	@Output() downloadInParent = new EventEmitter();
	@Output() cancelInParent = new EventEmitter();
	@Output() deleteFromParent = new EventEmitter();
	@Output() UndoFromParent = new EventEmitter();
	@Output() exportExcelInParent = new EventEmitter();
	@Output() exportPdfInParent = new EventEmitter();
	@Output() changeIPSwitch = new EventEmitter();
	@Output() exportInParent = new EventEmitter();
	@Output() editCell = new EventEmitter();
	@Output() jobError = new EventEmitter();
	@Output() Filter = new EventEmitter();
	@Output() staticDataApprovalActionEmit = new EventEmitter();
	@Output() jobErrorAction = new EventEmitter();

	@Input() canDisplay: any;
	@Input() canExport: any;
	@Input() canHideExportPdf: any;
	@Input() exportCSVFileName: any;
	@Input() dateRangeFromParent: any

	audio: any;
	clickPlay: boolean = false;
	audioEnd: boolean = false;
	playIndex: string = "";
	@ViewChild(Calendar, { static: false }) calendar!: Calendar;
	checked: boolean = false;
	@Input() canEdit: boolean = false;
	@Input() type: any
	@ViewChild('dt') table!: Table;
	dateRanges :any = {
		received_time:'',
		// parsed_time:''
		parsed_time: null,
		created_time: [ new Date(),new Date()],
		// parsed_time: [ new Date(),new Date()],
		entry_date_time: [ new Date(),new Date()],
		export_date: [ new Date(),new Date()],
	}

	canEditEnumConfigDetails = { 'screenName': 'OPS', 'subModule': 'canEditEnumConfigDetails' };
	canEditCodeConfigDetails = { 'screenName': 'RISK', 'subModule': 'canEditCodeConfigDetails' };
	canDeleteAssetClassConfig = { 'screenName': 'RISK', 'subModule': 'canDeleteAssetClassConfig' }
	canEditAssetClassConfig = { 'screenName': 'RISK', 'subModule': 'canEditAssetClassConfig' }
	canEditCreditRating = { 'screenName': 'RISK', 'subModule': 'canEditCreditRating' }
	canDeleteCreditRating = { 'screenName': 'RISK', 'subModule': 'canDeleteCreditRating' }
	canEditDcConfigDetails = { 'screenName': 'OPS', 'subModule': 'canEditDcConfigDetails' };
	canEditHolidayCalendar = { 'screenName': 'OPS', 'subModule': 'canEditHolidayCalendar' };
	canEditCAConfigDetails = { 'screenName': 'RISK', 'subModule': 'canEditCAConfigDetails' };
	canViewCAConfigDetails = { 'screenName': 'RISK', 'subModule': 'canViewCAConfigDetails' };
	canEditNewsletterConfigDetails = { 'screenName': 'NewsLetters', 'subModule': 'canEditNewsletterConfigDetails' };
	canEditNewsletterMappingDetails = { 'screenName': 'NewsLetters', 'subModule': 'canEditNewsletterMappingDetails' };
	// Edit Liquidity Configs Privilages
	canAccessEditLiquidityProfileNonMmfThresholdConfig = { 'screenName': 'Liquidity', 'subModule': 'canAccessEditLiquidityProfileNonMmfThresholdConfig' };
	canAccessEditLiquidityProfileMmfThresholdConfig = { 'screenName': 'Liquidity', 'subModule': 'canAccessEditLiquidityProfileMmfThresholdConfig' };
	canAccessEditLiquidationCostThresholdConfig = { 'screenName': 'Liquidity', 'subModule': 'canAccessEditLiquidationCostThresholdConfig' };
	// Delete Liquidity Configs Privilages
	canAccessDeleteLiquidityProfileNonMmfThresholdConfig = { 'screenName': 'Liquidity', 'subModule': 'canAccessDeleteLiquidityProfileNonMmfThresholdConfig' };
	canAccessDeleteLiquidityProfileMmfThresholdConfig = { 'screenName': 'Liquidity', 'subModule': 'canAccessDeleteLiquidityProfileMmfThresholdConfig' };
	canAccessDeleteLiquidationCostThresholdConfig = { 'screenName': 'Liquidity', 'subModule': 'canAccessDeleteLiquidationCostThresholdConfig' };
	// Edit Fund
	canEditFund = { 'screenName': 'ManageFund', 'subModule': 'canEditFund' };
	// Salesperson Screens
	canEditSalesPerson = { 'screenName': 'CCASS', 'subModule': 'canEditSalesPerson' };
	canDeleteSalesPerson = { 'screenName': 'CCASS', 'subModule': 'canDeleteSalesPerson' };
	// Sales Team Screens
	canEditSalesTeam = { 'screenName': 'CCASS', 'subModule': 'canEditSalesTeam' };
	canDeleteSalesTeam = { 'screenName': 'CCASS', 'subModule': 'canDeleteSalesTeam' };
	// CCASS PD Screens
	canEditParticipantDealer = { 'screenName': 'CCASS', 'subModule': 'canEditParticipantDealer' };
	canDeleteParticipantDealer = { 'screenName': 'CCASS', 'subModule': 'canDeleteParticipantDealer' };
	// CCASS fund Screen
	canEditCcassFund = { 'screenName': 'CCASS', 'subModule': 'canEditFund' };

	checkBoxSelection: any;
	selectedOptions: { [key: string]: any[] } = {};
	pageIndex: any = 0;
	isChecked: boolean = false;
	target: any;
	check: any;

	constructor(public privilegeService: PrivilegeService, private config: PrimeNGConfig) { }

	ngOnInit() {
		this.audio = new Audio();
		this.audioEnd = false;
		this.tableSchema['rowsCount'] = this.tableSchema?.rowsCount || 10;
		if (this.canDisplay === undefined) { this.canDisplay = true; }
		this.isChecked = false
		this.checked = false
	}

	ngOnChanges(simpleChanges: SimpleChanges) {
		if (simpleChanges["dateRangeFromParent"]) {
			for (const [key, value] of Object.entries(this.dateRangeFromParent) as [string, any][]) {
				this.dateRanges[key] = [new Date(value["fromDate"]), new Date(value["toDate"])];
			}
		}
	}

	/**
	 * Stores the filtered data and the applied filter settings when a table filter event is triggered
	 * 
	 * @param event On table apply filter event, the table information will be captured in this variable
	 * @param dt Contains the datatable information at the point of filter event
	 * @returns void
	 */
	onFilter(event: any, dt: any) {
		this.filteredDataList = event.filteredValue;
		this.appliedFilters = event.filters;
	}

	changeInputSwitch(event: any, id: any, rowData: any) { this.changeIPSwitch.emit({ event: event, id: id, rowData: rowData }); }

	/**
	 * Fire export Excel event to export either the filtered data if available, else the entire data
	 * 
	 * @param data Contains all data from the table
	 */
	exportExcel(data: any) {
		if (this.filteredDataList) {
			this.exportExcelInParent.emit(this.filteredDataList);
		} else {
			this.exportExcelInParent.emit(data);
		}
	}
	
	getFilteredOutput(event: any, dt: any) { this.geteventData.emit(event) }

	exportPdf(columns: any, data: any) {
		if (this.filteredDataList) {
			this.exportPdfInParent.emit({ columns: columns, data: this.filteredDataList });
		} else {
			this.exportPdfInParent.emit({ columns: columns, data: data });
		}
	}

	getStyleClass(col: any, rowData: any) {
		let className: any;
		col.styleProps.forEach((element: any) => {
			if (element.checkValue === rowData[col.field]) { className = element.class; }
		});
		return className;
	}

	onSelectDateRange(dates: any, field: any, checkingParameter: any) {
		if (dates[0] && dates[1]) {
			this.getDataBasedOnRange.emit({ dates: dates , field:field});
			this.calendar.hideOverlay();
			this.pageIndex = 0
		}
	}

	onSelectDate(date: any) {
		if (date) {
			this.getDataBasedOnDate.emit(date);
			this.calendar.hideOverlay();
		}
	}

	onClickClose() {
		this.closeCalender.emit();
	}
	onClickClosetps(field:string){
		this.closeCalender.emit(field)
	}

	onSelectRow() {
		let newList: any[] = []
		if (this.type === 'Trading_Holding' || this.type === 'Ccy_Settlement_Holding' || this.type === 'OPS_Holiday') {
			this.selectedRows.forEach((element: any) => {
				this.value.forEach((element1: any) => {
					if (element.holiday_id === element1.holiday_id) { newList.push(element1); }
				});
			});
		}
		else if (this.type === 'Odetails') {
			this.selectedRows.forEach((element: any) => {
				this.value.forEach((element1: any) => {
					if (element.order_id === element1.order_id) { newList.push(element1); }
				});
			});
		} else if(this.type === 'newsletter_report') {
			this.selectedRows.forEach((element: any) => {
				this.value.forEach((element1: any) => {
					if (element.reportID == element1.reportID) { newList.push(element1) }
				})
			})
		} else if(this.type === 'approval_process') {
			this.selectedRows.forEach((element: any) => {
				this.value.forEach((element1: any) => {
					if(element.static_data_key == element1.static_data_key && element.event_type == element1.event_type) {
						newList.push( {
							event_type: element1['event_type'],
							static_data_key: element1['static_data_key'],
							requested_date: element1['requested_date']
						})
					}
				})
			})
		} else {
			this.selectedRows.forEach((selectedRow: any) => {
				this.value.forEach((parentTableRow: any) => {
					if (selectedRow.fund_id != undefined && parentTableRow.fund_id != undefined) {
						if (selectedRow.fund_id === parentTableRow.fund_id) {
							newList.push(parentTableRow);
							return;
						}
					} else if (selectedRow.exception_id != undefined && parentTableRow.exception_id != undefined) {
						if (selectedRow.exception_id === parentTableRow.exception_id) {
							newList.push(parentTableRow);
							return;
						}
					}
				});
			});
		}

		this.updateInParent.emit([...newList]);
		if (this.type === 'Odetails') {
			localStorage.setItem('dcSelectedRows', JSON.stringify([...newList]))
		} else {
			localStorage.setItem('selectedRows', JSON.stringify([...newList]));
		}
	}

	thousandSeparators(value: any) { return thousands_separators(value); }

	onRowUnselect(row: any) {
		let list: any[] = [];
		if (this.type === 'Odetails') {
			const cachedDCSelectedRows: any = localStorage.getItem('dcSelectedRows');
			this.selectedRows = JSON.parse(cachedDCSelectedRows);
			list = this.selectedRows.filter((obj: any) => row.data.order_id !== obj.order_id);
			this.selectedRows = [...list];
			localStorage.setItem('dcSelectedRows', JSON.stringify(this.selectedRows));
		} else {
			const cachedSelectedRows: any = localStorage.getItem('selectedRows');
			this.selectedRows = JSON.parse(cachedSelectedRows);
			if (this.type === 'Trading_Holding' || this.type === 'Ccy_Settlement_Holding' || this.type === 'OPS_Holiday') {
				list = this.selectedRows.filter((obj: any) => row.data.holiday_id !== obj.holiday_id);
			} else if (this.type == 'newsletter_report') {
				list = this.selectedRows.filter((obj: any) => row.data.reportID !== obj.reportID);
			} else if (this.type == 'approval_process'){
				list = this.selectedRows.filter((obj: any) => {
					// !(row.data.static_data_key == obj.static_data_key || row.data.event_type == obj.event_type)
					if (row.data.static_data_key == obj.static_data_key && row.data.event_type == obj.event_type) {
					} else {
						return {
							event_type: obj['event_type'],
							static_data_key: obj['static_data_key'],
							requested_date: obj['requested_date']
						}
					}
				});
			} else {
				list = this.selectedRows.filter(function (obj: any) {
					if (row.data.tradar_code !== undefined && obj.tradar_code !== undefined) {
						return row.data.tradar_code !== obj.tradar_code
					} else if (row.data.exception_id !== undefined && obj.exception_id !== undefined) {
						return row.data.exception_id !== obj.exception_id
					}
				});
			}

			this.selectedRows = [...list];

			localStorage.setItem('selectedRows', JSON.stringify(this.selectedRows));
		}
		this.updateInParent.emit(this.selectedRows);
	}

	selectAllRows() {
		if (this.type === 'Odetails') {
			localStorage.setItem('dcSelectedRows', JSON.stringify(this.selectedRows));
		} else {
			localStorage.setItem('selectedRows', JSON.stringify(this.selectedRows));
		}
		this.updateInParent.emit(this.selectedRows);
	}

	onClickEdit(row: any, index: any) { this.editInParent.emit({ row: row, index: index }); }

	onClickStop(row: any,field: any) { this.stopInParent.emit({ row: row, field: field }); }

	onClickView(row: any, index: any) {
		let selectedFund: any[] = [];
		selectedFund.push(row);
		if (this.type === 'Odetails') {
			localStorage.setItem('dcSelectedRows', JSON.stringify(selectedFund));
		} else {
			localStorage.setItem('selectedRows', JSON.stringify(selectedFund));
		}
		this.viewInParent.emit({ row: row, index: index });
	}

	onClickViewMore(row: any, index: any, field: any) { this.viewMore.emit({ row: row, index: index, field: field }); }

	onClickViewParams(row: any, index: any) { this.viewParams.emit({ row: row, index: index }); }

	onClickViewLogo(row: any, index: any) { this.viewLogo.emit({ row: row, index: index }); }

	onClickUpdate(data: any) { this.updateInParent.emit(data); }

	onClickCancel() { this.cancelInParent.emit(); }

	onClickDelete(data: any) { this.deleteFromParent.emit(data); }

	onDeleteClick(data: any, index: any) {
		// if(this.privilegeService.isAuthorized(this.canDeleteReconConfigDetails))
		this.deleteFromParent.emit({ row: data, index: index });
	}
	onUndoeClick(data: any, index: any) { this.UndoFromParent.emit({ row: data, index: index }); }

	onClickLog(data: any) { this.summary.emit(data); }

	test(data: any) { this.showDialog.emit(data); }

	getFundName(data: any) {
		const fund = this.fundList.filter((obj: any) => obj['_id'] === data);
		return fund.length > 0 ? fund[0]['name'] : '';
	}

	convertLang(language: any) {
		let lang: any;
		if (language?.length > 0) {
			language.forEach((obj: any) => {
				switch (obj) {
					case 'EN': lang = 'English'; break;
					case 'TCH': lang = lang ? lang + ',' + 'Traditional Chinese' : 'Traditional Chinese'; break;
				}
			});
		}
		return lang;
	}

	showFundNames(funds: any) {
		let fund: any = funds.map((fund: any) => fund.label);
		return fund;
	}
	
	download(document: any) { window.open(document['url'], '_blank'); }

	onClickDownload(data: any) { this.downloadInParent.emit(data); }

	onClickPlay(audioDoc: any, index: any) {
		this.audioEnd = false;
		this.playIndex = index;
		this.audio.src = audioDoc.url;
		this.audio.load();
		this.audio.play();
		const method = this;
		this.audio.addEventListener('ended', function () {
			method.callMethod();
		}, false);
	}

	onClickPause(audioDoc: any, index: any) {
		this.audio.pause();
		this.audioEnd = true;
	}

	callMethod() { this.audioEnd = true; }

	showStop(index: any) {
		if (index === this.playIndex && !this.audioEnd) {
			return true;
		}
		return false;
	}

	canView(col: any) { return ((this.canDisplay && col['display']) || col['display'] || this.canDisplay); }

	onClickRowDetail(rowData: any) {
		// if (file.tradar_code !== 'CO-A50F') { return; } // Why is this here?
		this.editInParent.emit(rowData);
	}

	onClickExport(row: any, label: any) { this.exportInParent.emit({ row: row, label: label }); }

	onEditInit(event: any): void {
		this.check = null
		switch (event.field) {
			case "value":
				this.check = event.data.value
				break;
			case "fxrate":
				this.check = event.data.fxRate
				break;
		}
	}

	onEditCancel(): void { }

	onEditComplete(event: any) {
		this.target = event.originalEvent.target.toString()
		switch (event.field) {
			case "value":
				if (this.check !== event.data.value) { this.editCell.emit({ data: event.data }); }
				break;
			case "fxrate":
				if (this.check !== event.data.fxRate) { this.editCell.emit({ data: event.data }); }
				break;
		}
	}

	onClickErrorJobs(event: any, actionName: any, field?: string) {
		this.jobError.emit({ actionName: actionName, data: event, field: field });
	}

	onClickJobErrorAction(event: any, actionName: any) {
		switch (actionName) {
			case 'clear':
				this.jobErrorAction.emit({ actionName: actionName , data: event });
				break;
			case 'done':
				this.jobErrorAction.emit({ actionName: actionName , data: event });
				break;
			case 're-queue':
				this.jobErrorAction.emit({ actionName: actionName , data: event });
				break;
		}
	}

	// Handles multiSelect filter logic to ensure 'ALL' (null) shows all results and stays
	// mutually exclusive with specific selections (checking one unchecks the other).
	onMultiSelectChange(selectedList: any[], field: string, dt: any) {
		const isAllOption = (value: any) => value === null || value === undefined;
		const previousList = this.selectedOptions[field] || [];
		const previousHasAll = previousList.some(isAllOption);
		const newHasAll = selectedList.some(isAllOption);

		let finalList = selectedList;
		if (newHasAll && selectedList.length > 1) {
			finalList = previousHasAll
				// 'All' was already checked, user just checked a specific item -> drop 'All'
				? selectedList.filter((value: any) => !isAllOption(value))
				// user just checked 'All' while specific items were checked -> drop the specific items
				: selectedList.filter(isAllOption);
		}

		this.selectedOptions[field] = finalList;
		dt.filter(finalList.length === 0 || finalList.some(isAllOption) ? null : finalList, field, 'in');
	}

	statusDropdownChanged(col: string, row: any){
		const data = { field: col, row: row }
		this.Filter.emit(data)
	}

	staticDataApprovalAction(rowData: {[key:string]:string}, actionType: string){
		const data = { data: rowData, actionType: actionType }
		this.staticDataApprovalActionEmit.emit(data)
	}

	onClickMessageData(rowData: {[key:string]:string}){
		const data = { data: rowData }
		this.messageData.emit(data)
	}
}